import {
  SET_API_TOKENS,
  DELETE_API_TOKEN,
  CREATED_API_TOKEN,
  CLEAN_CREATED_API_TOKEN
} from './mutationTypes';
import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';
import { remove } from 'lodash';

export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_API_TOKENS](state, apiTokensList) {
    state.apiTokensList = apiTokensList;
  },

  [DELETE_API_TOKEN](state, apiTokenModel) {
    remove(state.apiTokensList, (token) => {
      return token.tokenId === apiTokenModel.tokenId;
    });
  },

  [CREATED_API_TOKEN](state, response) {
    state.createdApiTokenResponse = response;
  },

  [CLEAN_CREATED_API_TOKEN](state) {
    state.createdApiTokenResponse = {};
  }
};